import React from 'react';
import classNames from "classnames";
import styles from "../styles/standings-widget.module.scss";
import {TAG_TITLE} from "../../../core/app/consts";
import {SVGImage} from "../../../core/components/image/svg-image";
import {useThemeColor} from "../../../infrastructure/hooks/useThemeColor";
import {COLORS} from "../../../core/app/consts/colors";

export const StandingsWidgetSectionIconTitle = ({controller, label, iconSource}) => {
  const {device} = controller;
  const {isSmallView} = device;

  const TitleTag: String = isSmallView ? TAG_TITLE.h2 : TAG_TITLE.h3;

  const imageProps = {
    src: iconSource,
    className: classNames(styles.section_title_icon),
    fillcolor: useThemeColor(COLORS.textSecondary)
  }

  return (
    <TitleTag className={classNames(styles.section_title)}>
      <SVGImage {...imageProps}/>
      {label}
    </TitleTag>
  )
};